import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-sky-100 bg-sky-50/60 py-14" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 sm:px-10 md:flex-row md:items-start md:justify-between lg:px-14">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-700 text-white">
            <GraduationCap size={18} />
          </span>
          <span className="font-display text-lg font-bold text-slate-900">Jyoti Academy</span>
        </div>
        <p className="mt-3 text-xs font-semibold tracking-wide text-amber-700" data-testid="footer-tagline">Find your unknown, work on it, level up</p>
        <p className="mt-4 max-w-xs font-odia text-lg text-amber-700">ସା ବିଦ୍ୟା ଯା ବିମୁକ୍ତୟେ ।</p>
        <p className="mt-1 text-xs text-slate-500">Knowledge is that which liberates.</p>
      </div>

      <div className="flex gap-16">
        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-700">Explore</p>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
            <li><Link to="/inspirations" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-inspirations-link">Inspirations</Link></li>
            <li><Link to="/notices" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-notices-link">Notices</Link></li>
            <li><Link to="/gallery" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-gallery-link">Info Gallery</Link></li>
            <li><Link to="/socials" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-socials-link">Socials</Link></li>
            <li><Link to="/terms" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><a href="https://tally.so/r/J9yWGo" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-enroll-link">Enroll — OTET 1 &amp; 2</a></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-sky-700">Contact</p>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-600">
            <li>
              <a href="https://wa.me/917751946736" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 hover:text-sky-700" data-testid="footer-whatsapp-link">
                77519 46736 — WhatsApp message only
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <p className="mx-auto mt-12 max-w-7xl px-6 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400 sm:px-10 lg:px-14">
      © 2026 Jyoti Academy · <span className="font-odia normal-case tracking-normal">ତମସୋ ମା ଜ୍ୟୋର୍ତିଗମୟ ।</span>
    </p>
  </footer>
);
